export const gtmSearchFilterEvent = (filterId: string, filterOption: string | boolean, applied: boolean) => {
  return {
    event: 'CTA checkbox click',
    eventCategory: 'Filter',
    eventLabel: filterOption,
    filterId,
    filterOption,
    detail: applied ? 'apply' : 'remove',
  };
};

export default gtmSearchFilterEvent;
